/** Hooks de sessão compartilhados: a empresa ativa (a API confere o vínculo em cada pedido). */
import { useSyncExternalStore } from "react";
import { getActiveCompanyId, subscribeActiveCompany } from "./company-store";

export function useActiveCompanyId(): string | null {
  return useSyncExternalStore(subscribeActiveCompany, getActiveCompanyId, () => null);
}
